const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
// src/api/productApi.js
// Minimal wrapper for /buyer/get-products

const BASE_URL = API_BASE_URL;

function getAuthHeaders() {
  const token =
    sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  return token ? { token } : {};
}

export async function getProducts(filters = {}, page = 1, limit = 10) {
  const body = { filters, page, limit };

  const res = await fetch(`${BASE_URL}/buyer/get-products`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify(body),
  });

  // return parsed JSON; caller will decide how to read result
  return res.json();
}
